import React from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'
import SummaryJewelry from '../summary-jewelry'
import HorizontalRule from '../horizontal-rule'
import Spacer from '../spacer'

const SummaryJewelryList = props => (
  <div>
    {
      _map(props.jewelry, (jewelry, key) => <SummaryJewelry key={`jewelry${key}`} jewelry={jewelry} price={props.prices[key]} index={key} />)
        .reduce((acc, element, index) => (acc ? [...acc, <div key={`hr${index}`}><HorizontalRule /><Spacer xs /></div>, element] : [element]), null)
    }
  </div>
)

SummaryJewelryList.propTypes = {
  jewelry: PropTypes.object.isRequired,
  prices: PropTypes.object.isRequired
}

export default SummaryJewelryList



// WEBPACK FOOTER //
// ./src/components/summary-jewelry-list/index.js